export default function stateConfig($stateProvider, $urlRouterProvider, $compileProvider, $logProvider, $locationProvider) {
  'ngInject';
  $stateProvider.state('searchEngineFrontend', {
    abstract: true,
    template: '<ui-view></ui-view>'
  });

  $urlRouterProvider.otherwise('/');
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });

  // go/generator-webpack-globals
  if ( __PRODUCTION__ ) {
    $compileProvider.debugInfoEnabled(false);
    $logProvider.debugEnabled(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.config.js